import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchTemplatePageDataFromApi, useTemplatePageDataFromApi } from './pageData';

export type TemplatePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useTemplatePageDataFromApi>[0];
}>;

export type TemplateCombinedState = ReturnType<typeof useTemplatePageDataFromApi>;

export function usePageContext(prefetchedData?: TemplatePrefetchedContext): TemplateCombinedState {
	const { slug } = useKnownAvailableParams<{ slug: string }>();
	return useTemplatePageDataFromApi(prefetchedData?.pageData, slug);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<TemplatePrefetchedContext> {
	const { slug } = context.params;
	const pageData = await prefetchTemplatePageDataFromApi(context, slug);
	return { pageData };
}

export type TemplatePrefetchedDataProps = PrefetchedDataProps<TemplatePrefetchedContext>;
